import {AppService} from "@core/services/app.service";
import {CookiePosService} from "@core/services/cookie-pos.service";
import {STORAGE_KEY} from "@core/constants";
import {isPlatformBrowser} from "@angular/common";

export function isEnvironmentLocal(platformId: object) {
  if (isPlatformBrowser(platformId)) {
    return window.location.hostname.endsWith('.local');
  }
  return false; // Mặc định trả về `false` khi chạy trên server
}

export function isLoginEd(_app: AppService, _cookieService: CookiePosService) {
  return Object.keys(_app.store.get(STORAGE_KEY.accessToken)).length > 0;
}
